import { ClientInfoType, knownAADClientInfo } from '@citrite/msal-browser';
import {
	getDefaultAADClientInfo,
	isFeatureEnabledCitrixAAD_SSO_GA,
} from 'Environment/msal/clientInfoUtils';

const AADSSOLogonType = 'AzureAD';
const AADSSOFieldsInICA = [
	'SSOnLogonType',
	'AzureDeviceId',
	'InitialProgram',
	'AzureSSOnClientId',
	'AzureSSOnResourceAppId',
	'AzureSSOnRedirectUrl',
	'AzureSSOnAuthorizeUrl',
] as const;

export type AADSSOICAContents = {
	[K in typeof AADSSOFieldsInICA[number]]?: string;
} & { resourceId?: string };

export function parseResourceId(initialProgram: string): string {
	return initialProgram && initialProgram.length > 1 ? initialProgram.substring(1) : '';
}

export function doesResourceLaunchSupportAADSSO(
	aadSsoFieldsInICA: AADSSOICAContents
): boolean {
	return (
		typeof aadSsoFieldsInICA?.AzureDeviceId === 'string' &&
		aadSsoFieldsInICA?.SSOnLogonType === AADSSOLogonType &&
		aadSsoFieldsInICA.resourceId.length > 0
	);
}

export function buildMSALClientInfo(
	aadSsoFieldsInICA: AADSSOICAContents
): ClientInfoType {
	//Use the MicrosoftSample client info for the non-GA version of AAD SSO
	if (!isFeatureEnabledCitrixAAD_SSO_GA()) {
		return knownAADClientInfo.MicrosoftSample;
	}

	const { clientId, redirectUri, resourceAppId, authority } = getDefaultAADClientInfo();

	// Prefer the values from the ICA file over the default ones until the GA version is available
	return {
		clientId: aadSsoFieldsInICA.AzureSSOnClientId ?? clientId,
		redirectUri: aadSsoFieldsInICA.AzureSSOnRedirectUrl ?? redirectUri,
		resourceAppId: aadSsoFieldsInICA.AzureSSOnResourceAppId ?? resourceAppId,
		authority: aadSsoFieldsInICA.AzureSSOnAuthorizeUrl ?? authority,
	};
}
